
import React from 'react';
import { Container, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import './FinalExpenseAbout.scss';

export default function About(props) {
  const { data } = props;

  return (
    <Container fluid className='final-expense-about' id="final-expense-about">
      <Row className="justify-content-center">
        <h2 className="text-center about-title mb-3">{data.title}</h2>
      </Row>
      <Row className="justify-content-center">
        <p className='about-content'>{data.content}</p>
      </Row>
      <Row className="specification main-content">
        <Accordion className='accordion'>
          <AccordionSummary
            expandIcon={<KeyboardArrowDownIcon color="primary" />}
            aria-controls="panel1-content"
            className="py-2 px-0"
            role=''
          >
          <div className={`specification primary-color`}>PRODUCT SPECIFICATIONS</div>
          </AccordionSummary>
          <AccordionDetails className="pb-3 px-0 pt-0">
            {data.productData.map((d, index) =>
              <div key={index}>
                <h3 className='specification-title'>{d.title}</h3>
                <p className='specification-content'>{d.text}</p>
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      </Row>
    </Container>
  );
};

About.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};
